import {
  Directive,
  ElementRef,
  HostListener, OnDestroy,
  OnInit
} from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';

@Directive({
    selector: '[appCollapsible]',
    standalone: true,
})
export class CollapsibleDirective implements OnInit, OnDestroy {
  collapseSubscription!: Subscription;
  arrowIcon!: HTMLElement;
  private _collapsed$ = new BehaviorSubject<boolean>(true);

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    this.el.nativeElement.style.display = 'flex';
    this.el.nativeElement.style.justifyContent = 'space-between';
    this.el.nativeElement.style.alignItems = 'center';

    this.el.nativeElement.style.cursor = 'pointer';
    this.arrowIcon = document.createElement('span');
    this.arrowIcon.classList.add('icon');
    this.el.nativeElement.appendChild(this.arrowIcon);

    this.collapseSubscription = this._collapsed$.subscribe(
      (collapsed: boolean) => {
        if (collapsed) {
          this.collapse();
        } else {
          this.uncollapse();
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this.collapseSubscription) {
      this.collapseSubscription.unsubscribe();
    }
    this.uncollapse();
    this.arrowIcon.remove();
  }

  collapse(): void {
    this.arrowIcon.classList.add('icon-arrow-down');
    this.arrowIcon.classList.remove('icon-arrow-up');
    let nextSibling = this.el.nativeElement.nextElementSibling;
    while (nextSibling) {
      nextSibling.classList.add('display-none');
      nextSibling = nextSibling.nextElementSibling;
    }
  }

  uncollapse(): void {
    this.arrowIcon.classList.add('icon-arrow-up');
    this.arrowIcon.classList.remove('icon-arrow-down');
    let nextSibling = this.el.nativeElement.nextElementSibling;
    while (nextSibling) {
      nextSibling.classList.remove('display-none');
      nextSibling = nextSibling.nextElementSibling;
    }
  }

  @HostListener('click')
  onClick() {
    this._collapsed$.next(!this._collapsed$.getValue());
  }
}
